import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "reportfooter",
  class: "report-footer d-flex flex-row justify-content-between d-md-none"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Open as PDF ")
const _hoisted_3 = {
  class: "report-footer__top d-flex flex-row align-items-center",
  href: "#top"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Back to top ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "report-footer__download d-flex flex-row align-items-center",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDownload()))
    }, [
      _hoisted_2,
      _createVNode(_component_font_awesome_icon, {
        icon: "external-link-alt",
        class: "report-footer__download__icon"
      })
    ]),
    _createElementVNode("a", _hoisted_3, [
      _createVNode(_component_font_awesome_icon, {
        icon: "chevron-up",
        class: "report-footer__top__icon"
      }),
      _hoisted_4
    ])
  ]))
}